import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useGlobalFilter, usePagination, useTable } from "react-table";
import NormalPagination from "../../components/pagination/NormalPagination";
import { ReactComponent as Down } from "../../images/links/down.svg";
import { ReactComponent as DownGrey } from "../../images/links/down_grey.svg";
import { ReactComponent as Up } from "../../images/links/up.svg";
import { ReactComponent as UpGrey } from "../../images/links/up_grey.svg";
import NormalBox from "../../public/boxes/NormalBox";
import { ALL_ROLES, DEFAULT_ROWS_PER_PAGE, EMAIL, FIRST_NAME, LAST_NAME, NO_RESULTS_FOUND, ROLE, TEXTBOX, USERNAME } from "../../utils/constants";
import { roleDisplayToValue, roleValue2Display } from "../../utils/helpers";
import styles from "./CourseContent.module.css";
import {ReactComponent as NoResultIllustration} from "../../images/no_result.svg";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
export default React.memo(CourseMemberTable);
function CourseMemberTable({ data = [], setData, columns = [], globalFilterObj = {}, sortUserName, sortFirstName, sortLastName, sortRole, sortEmail, userNameSort, firstNameSort, lastNameSort, roleSort, emailSort}) {
    const [scrollableContainer, setScrollableContainer] = useState(false);
    const [sortedBy, setSortedBy] = useState("");


    const filterCustomize = (rows, columnIds, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const {keyword, role=ALL_ROLES} = globalFilterValue;
        const filteredKeyword = keyword ? keyword.toLowerCase() : "";
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.userName && values.userName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (values.firstName && values.firstName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (values.lastName && values.lastName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            return false;
        }).filter(r => {
            if (role === ALL_ROLES) {
                return true;
            }
            const values = r.values;
            if (values.role && values.role === roleDisplayToValue(role)) {
                return true;
            }
            return false;
        });
    };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex },
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: DEFAULT_ROWS_PER_PAGE },
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);

    useEffect(() => {
        setGlobalFilter(globalFilterObj);
    }, [globalFilterObj]);

    useEffect(() => {
        const container = document.getElementById("course-content-container");
        setScrollableContainer(container.scrollWidth > container.clientWidth || container.scrollHeight > container.clientHeight);
    }, [data]);

    return (
        <>
            <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                    <Table responsive hover {...getTableProps()} style={{margin: "0px"}}>
                        <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps({
                                style: {
                                }
                            })}>
                                {headerGroup.headers.map((column, idx) => (
                                    <TableSortHeaderNew
                                        key={idx}
                                        data={data}
                                        setData={setData}
                                        sortedBy={sortedBy}
                                        setSortedBy={setSortedBy}
                                        propertyName={column.id}
                                        getProperty={(item) => item[column.id].toString()}
                                        label={column.Header}
                                        {...{
                                            // ...column.getHeaderProps(),
                                            key: column.id,
                                            style: {
                                                width: column.width,
                                                textAlign: 'left',
                                                backgroundClip: "padding-box",

                                            }
                                        }}
                                    >
                                        <span style={{paddingLeft: column.Header === USERNAME ? 10 : undefined}}>
                                            {column.Header}
                                        </span>
                                    </TableSortHeaderNew>
                                ))}
                            </tr>
                        ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                        {page && page.length !== 0 ? page.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => {
                                        return (
                                            <td {...cell.getCellProps({
                                                style: {
                                                    // width: '100%',
                                                    //
                                                    // fontStyle: 'normal',
                                                    // fontWeight: '400',
                                                    // fontsize: '1.25rem',
                                                    // lineHeight: '1.25rem',
                                                    // letterSpacing: '0.035em',
                                                    // height: '4rem',
                                                    // overflowX: 'hidden',
                                                    // whiteSpace: 'nowrap',
                                                    // textOverflow: 'ellipsis',
                                                    // border: '1px solid #000000'
                                                    wordBreak: 'break-word'
                                                }
                                            })}>
                                                <div className={cell.column.Header === USERNAME ? styles.userNameCell : styles.tableBody}>
                                                    {cell.column.Header === ROLE ? roleValue2Display(cell.value) : cell.value}
                                                </div>
                                            </td>
                                        );

                                    })}
                                </tr>
                            )
                        }) : <tr><td colSpan="5" className={styles.noData} style={{boxShadow: "none"}}><div style={{height: 400, display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", justifyContent: "center"}}> <NoResultIllustration /> <div style={{fontSize: "20px", lineHeight: 1.4,  marginTop: "10px", fontWeight: 600}}> {NO_RESULTS_FOUND} </div> </div></td></tr>}
                        </tbody>
                    </Table>
                </div>
            </div>

            {page && page.length !== 0 ? <>
                {!scrollableContainer && <div style={{height: "0px", marginTop: "40px"}}/>}
                <div style={scrollableContainer ? {marginTop: "10px"} : {position: "absolute", bottom: "25px"}}>
                    <NormalPagination
                        pageCount={pageCount}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        gotoPage={gotoPage}
                        paddingTop="20px"
                    />
                </div>
            </> : <></>}
        </>
    );
}
